// extracted by mini-css-extract-plugin
module.exports = {"main":"WikiHowLink_main__ywSU3","textLink":"WikiHowLink_textLink__2nw2D","howToLink":"WikiHowLink_howToLink__AbxpE"};